import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-pdf-viewer',
  standalone: true,
  imports: [CommonModule, PdfViewerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (viewerSrc) {
      <pdf-viewer
        [src]="viewerSrc"
        [render-text]="false"
        [original-size]="false"
        [fit-to-page]="true"
        [show-all]="true"
        [style.height]="height"
        style="display: block; width: 100%;border: 1px solid #e5e7eb;
          border-radius: 0.5rem;
          overflow: hidden;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);"
      />
    } @else {
      <div class="empty">Kein PDF geladen</div>
    }
  `,
})
export class PdfViewerComponent implements OnChanges {
  @Input() pdf?: Blob | Uint8Array | ArrayBuffer;
  @Input() height = '450px';

  viewerSrc?: Uint8Array;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['pdf'] || !this.pdf) return;

    if (this.pdf instanceof Blob) {
      this.pdf.arrayBuffer().then(buf => {
        this.viewerSrc = new Uint8Array(buf);
        this.cdr.markForCheck();
      });
    } else if (this.pdf instanceof Uint8Array) {
      this.viewerSrc = new Uint8Array(this.pdf);
    } else {
      // ArrayBuffer
      this.viewerSrc = new Uint8Array(this.pdf);
    }
  }
}